import api from './api';
import {setToken} from './servicesGetCookie';

export const UpdateUser = async(UserEdit) =>{
    const AUTH_TOKEN = setToken();
    const resposta = await api.post(`UpdateUser`,{
         MyId : UserEdit.MyId,
         Name : UserEdit.Name,
         Email : UserEdit.Email,
         SubscribeDate : UserEdit.SubscribeDate,
         ValidDate : UserEdit.ValidDate,
         Admin : UserEdit.Admin?1:0,
         PlanPrice : UserEdit.PlanPrice || '0,00',
         PlanCurrentPrice : UserEdit.PlanCurrentPrice || '0,00',
        },{'headers':{'Authorization':`Bearer ${AUTH_TOKEN}`}} ).then((response)=>{
        return response.data;

    }).catch((error)=>{

            return error.response;

    })

    return resposta;
}
